import { NumberInputProps } from '@any-ui-react/core';
import { z } from 'zod';

import { ValueEditorInputProps } from './useValueEditor';

interface UseNumberEditorReturnProps extends NumberInputProps {
  type: 'text';
  getNumberEditorValue: (i?: number) => number | '';
  handleNumberEditorValueChange: (i?: number) => (value: number) => void;
}

export const useNumberEditor = ({
  field: { componentProps },
  values,
  handleSingleValue,
  handleMultipleValues,
}: ValueEditorInputProps): UseNumberEditorReturnProps => {
  return {
    type: 'text',
    getNumberEditorValue: (i = 0) => {
      const value = values?.[i];
      if (!value) return '';

      const result = z.coerce.number().safeParse(value);
      return result.success ? result.data : '';
    },
    handleNumberEditorValueChange: (i) => {
      if (i === undefined) {
        return (value) => handleSingleValue(value.toString());
      }

      return (value) => handleMultipleValues(value.toString(), i);
    },
    ...componentProps,
  };
};
